import translationsRO from './ro.json';

const translationsResources = {
  ro: {
    translation: translationsRO,
  },
};

export default translationsResources;
